import React from 'react'
import { Icon, Select, DatePicker, LocaleProvider } from "antd";
import moment from 'moment'
const { RangePicker } = DatePicker;
import Icons from '../../Images'
import zhCN from 'antd/lib/locale-provider/zh_CN'; // Example: Chinese locale
import viVN from 'antd/lib/locale-provider/vi_VN';
import thTH from 'antd/lib/locale-provider/th_TH';

import Config from './../../../Config'
const { Pushgtagpiwikurl, Pushgtagdata } = Config()

moment.updateLocale('zh-cn', {
    week: {
        dow: 0, // 0 表示星期日为起始日
    },
});

import 'moment/locale/zh-cn';
import 'moment/locale/th';
import 'moment/locale/vi';

export default class RouterFilter extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedDate: null,
            isShowDateRange: false
        }
    }

    disabledDate(current) {
        const { selectedDate } = this.state;
        const maxInterval = this.props?.MaxInterval || 90
        const maxRange = this.props?.MaxRange || 6

        const intervalFromDate = moment().subtract(maxInterval, 'days'); // 90天前
        const maxSelectableDate = selectedDate
            ? moment(selectedDate).add(maxRange, 'days') // 选择起始日后只能选择7天以内
            : moment();

        const maxDate = maxSelectableDate.isAfter(moment()) ? moment() : maxSelectableDate;
        const minDate = selectedDate ? moment(selectedDate) : intervalFromDate;

        return current && (current < minDate.startOf('day') || current > maxDate.endOf('day'));
    }


    toggleShowDateRange(isShowDateRange) {
        this.setState({
            isShowDateRange
        })
    }

    render() {
        let { ProgressStatus, format, ProgressStatusIndex, questionTypes, questionTypesIndex, onFilter, dateFrom, dateTo, changeDate, tempText, Language } = this.props
        let { isShowDateRange } = this.state
        let LocaleProviderObj = {
            M1: zhCN,
            M2: thTH,
            M3: viVN
        }
        let locale = LocaleProviderObj[Language]

        if (Language == 'M1') {

        } else if (Language == 'M2') {
            moment.updateLocale('th', {
                weekdays: ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์'],
                weekdaysShort: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
                weekdaysMin: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
            });
        } else if (Language == 'M3') {
            moment.updateLocale('vi', {
                weekdays: ['Chủ Nhật', 'Thứ Hai', 'Thứ Ba', 'Thứ Tư', 'Thứ Năm', 'Thứ Sáu', 'Thứ Bảy'],
                weekdaysShort: ['CN', 'HAI', 'BA', 'TƯ', 'NĂM', 'SÁU', 'BẢY'],
                weekdaysMin: ['CN', 'HAI', 'BA', 'TƯ', 'NĂM', 'SÁU', 'BẢY'], // 自定义星期名称
            });
        }





        return <div className='selectBtnWrap'>
            {
                Array.isArray(ProgressStatus) && !!ProgressStatus.length &&
                <Select
                    // autoFocus={true}
                    // defaultActiveFirstOption={true}
                    // dropdownMatchSelectWidth={true}
                    // open={true}
                    className='customerServiceSelect'
                    dropdownClassName='customerServiceSelectDropdown'
                    defaultValue={ProgressStatusIndex >= 0 ? ProgressStatus[ProgressStatusIndex]?.text : tempText?.text55}
                    showArrow={true}
                    onSelect={(value, { key }) => {
                        onFilter({
                            isSearch: true,
                            ProgressStatusIndex: key
                        })


                        Pushgtagpiwikurl('help_center_feedback_record', 'Help Center Feedback Record')
                        Pushgtagdata('HelpCenter', 'Filter Feedback Progress', 'HelpCenter_Record_C_FilterProgress', false,
                            [
                                {
                                    customVariableKey: "HelpCenter_Record_C_FilterProgress",
                                    customVariableValue: ProgressStatus[ProgressStatusIndex]?.text
                                }
                            ]
                        )
                    }}>
                    {
                        ProgressStatus.map((v, i) => {
                            let flag = ProgressStatusIndex == i
                            return <Option
                                key={i}
                                value={v?.text}
                                className='selectOption'
                                style={{
                                    background: flag ? '#EFEFF4' : 'transparent'
                                }}
                            >{v?.text}</Option>
                        })
                    }
                </Select>
            }



            {
                Array.isArray(questionTypes) && !!questionTypes.length &&
                <Select
                    className='customerServiceSelect'
                    dropdownClassName='customerServiceSelectDropdown'
                    defaultValue={questionTypesIndex >= 0 ? questionTypes[questionTypesIndex]?.questionType : tempText?.text17}
                    showArrow={true}
                    onSelect={(value, { key }) => {
                        onFilter({
                            isSearch: true,
                            questionTypesIndex: key,
                        })

                        Pushgtagpiwikurl('help_center_feedback_record', 'Help Center Feedback Record')
                        Pushgtagdata('HelpCenter', 'Filter Feedback Type', 'HelpCenter_Record_C_FilterType', false,
                            [
                                {
                                    customVariableKey: "HelpCenter_Record_C_FilterType",
                                    customVariableValue: questionTypes[questionTypesIndex]?.questionType
                                }
                            ]
                        )
                    }}>
                    {
                        questionTypes.map((v, i) => {
                            let flag = questionTypesIndex == i
                            return <Option
                                key={i}
                                value={v?.questionType}
                                className='selectOption'
                                style={{
                                    background: flag ? '#EFEFF4' : 'transparent'
                                }}
                            >{v?.questionType}</Option>
                        })
                    }
                </Select>
            }

            <div className='ant-select-show-arrow customerServiceSelect ant-select ant-select-enabled' onClick={() => {
                this.toggleShowDateRange(true)
            }}>
                <div className='ant-select-selection ant-select-selection--single'>
                    <div className='ant-select-selection__rendered'>
                        {
                            moment(new Date(dateFrom)).format(format.split(' ')[0])
                        }
                        <img
                            src={Icons.general}
                            className="general"
                        ></img>
                        {
                            moment(new Date(dateTo)).format(format.split(' ')[0])
                        }
                        <img
                            src={Icons.calendar1}
                            className="calendar1"
                        ></img>
                    </div>

                </div>
            </div>

            {
                isShowDateRange && <div className='customerServiceSelectDropdownChild-mask' onClick={() => {
                    this.toggleShowDateRange(false)
                }}></div>
            }

            <LocaleProvider locale={locale}>
                <RangePicker
                    value={[moment(dateFrom, 'YYYY-MM-DD'), moment(dateTo, 'YYYY-MM-DD')]}
                    defaultValue={[dateFrom, dateTo]}
                    allowClear={false}
                    className={'customerServiceSelect'}
                    dropdownClassName={`customerServiceSelectDropdown`}
                    disabledDate={this.disabledDate.bind(this)}
                    onChange={(value) => {
                        changeDate({
                            dateFrom: value[0],
                            dateTo: value[1],
                        })
                        this.toggleShowDateRange(true)
                        this.setState({
                            selectedDate: null
                        })
                    }}
                    onCalendarChange={value => {
                        this.setState({
                            selectedDate: value && value[0]
                        })
                    }}
                    open={isShowDateRange}
                    onOpenChange={(value) => {
                        // changeDate({
                        //     showDateRange: value
                        // })
                    }}
                    renderExtraFooter={() => {
                        return <div className='RangePickerFooter'>
                            <div className="rangePickerHeader">
                                <div className='pickerHeaderBox'>
                                    <div></div>
                                    <span className="pickerHeaderTitle1">{tempText?.text57}</span>
                                    <img
                                        onClick={() => {
                                            this.toggleShowDateRange(false)
                                        }}
                                        src={Icons.CustomerServiceClose}
                                        className="CustomerServiceClose"
                                    />
                                </div>
                                <div className="pickerHeaderTitle2">{tempText?.text59}</div>
                            </div>

                            <div
                                className="modalHeaderRightText"
                                onClick={() => {
                                    changeDate({
                                        dateFrom: moment(new Date()).subtract(6, 'days'),
                                        dateTo: moment(new Date()).subtract(0, 'days'),
                                    })
                                    this.toggleShowDateRange(true)
                                }}
                            >
                                {tempText?.text58}
                            </div>

                            <div className='confrimTimeBtn' onClick={() => {
                                changeDate({
                                    isSearch: true
                                })
                                this.toggleShowDateRange(false)
                            }}>
                                <div className="confrimTimeBtnText">{tempText?.text60} {moment(dateTo).diff(moment(dateFrom), 'days') + 1} {tempText?.text61}</div>
                            </div>
                        </div>
                    }}
                />
            </LocaleProvider>

        </div>
    }
}